import React, {useEffect, useRef} from "react";
import {t} from "../../../shared-services/translate";
import topLayerState from "../../../shared-services/globalState/topLayerState";
import useImageLoadWatch from "../../shared/useImageLoadWatch";

import {Container} from "../../../react-components/shared/SharedComponents";
import {FarmyColumnSet, FarmyColumn} from "../../layouts/components/FarmyColumns";
import HorizontalScroll from "../../../react-components/shared/HorizontalScroll";
import ComponentPlaceholder from "../../shared/ComponentPlaceholder";

import ProductImageBlock from "./ProductImageBlock";
import ProductDetails from "./ProductDetails";
import FavoritesTogglePDP from "./FavoritesTogglePDP";
import ProducerBlockPDP from "./ProducerBlockPDP";
import ProductInfo from "./ProductInfo";

import {Title1, Title2, Title3} from "../../layouts/components/Titles";
import currentTheme from "../../../react-themes/theme";
import NutritionalInfoPDP from "./NutritionalInfoPDP";
import RecommendationsPDP from "./RecommendationsPDP";
import Ingredients from "./Ingredients";
import AllergensPDP from "./AllergensPDP";

const theme = currentTheme();

const ProductPageMobile = (props) => {
  const {product} = props;

  const {
    setBottomDrawer,
    emptyBottomDrawer,
    setBottomNotification
  } = topLayerState();

  const {delivers_saturday: deliversSaturday} = product;

  const infoBlockRef = useRef();
  const {imagesLoadComplete} = useImageLoadWatch([product?.id]);

  const scrollToInfoBlock = () => {
    const element = infoBlockRef.current;
    if (!element) return;

    const scrollParams = {
      behavior: "smooth",
      block: "start"
    };

    element?.scrollIntoView(scrollParams);
  };

  useEffect(() => {
    if (!product?.id) return;

    setBottomDrawer({
      name: "CartBlockPDPMobile",
      props: {product}
    });

    return () => {
      emptyBottomDrawer();
    };
  }, [product]);

  useEffect(() => {
    if (product?.id && imagesLoadComplete && !deliversSaturday) {
      const bottomNotification = {
        name: "BottomSaturdayDelivery",
        autoHide: true
      };
      setBottomNotification(bottomNotification);
    }
  }, [imagesLoadComplete, product?.id]);

  return <div className="product-page-mobile">
    <Container>
      <ComponentPlaceholder
        className="full-width border-radius-0" style={{aspectRatio: "414 / 314"}}
        until={product?.id && imagesLoadComplete}
        hideChildren={false}
        transparent={product?.id}
      >
        <ProductImageBlock product={product}/>
      </ComponentPlaceholder>
    </Container>

    <Container className="mobile-container margin-top-20 margin-bottom-20">
      <ComponentPlaceholder
        until={product?.id}
        className="margin-top-5 margin-bottom-10"
        style={{
          minHeight: "40px"
        }}
      >
        <FarmyColumnSet className="gap-20 flex-wrap-nowrap">
          <FarmyColumn>
            <Title1 className={`
            margin-top-5
          `}>
              {product?.name}

            </Title1>
          </FarmyColumn>

          <FarmyColumn width="26px" strict={true} className="flex align-items-flex-start justify-content-flex-end">
            <FavoritesTogglePDP
              product={product}
              setProduct={props?.setProduct}
              size="26.4px"
              className="margin-top-10"
            />
          </FarmyColumn>
        </FarmyColumnSet>
      </ComponentPlaceholder>

      <ComponentPlaceholder
        until={product?.id}
        style={{minHeight: "415px"}}
      >
        <ProducerBlockPDP
          ref={infoBlockRef}
          producer={product?.supplier}
          scrollToInfoBlock={scrollToInfoBlock}
        />
      </ComponentPlaceholder>

      <Title2 className="text-color-green font-weight-600 margin-top-20 margin-bottom-10" style={{fontSize: "24px"}}>
        <ComponentPlaceholder
          until={product?.id}
          style={{minHeight: "26.4px"}}
        >
          {t("product_page.details")}
        </ComponentPlaceholder>
      </Title2>

      <hr
        style={{
          borderColor: theme.colors.farmy[product?.id ? "green" : "lightestGrey"],
          borderWidth: "2px"
        }}
        className="margin-top-10"
      />

      <ComponentPlaceholder
        until={product?.id}
        style={{minHeight: "160px"}}
      >
        <ProductDetails product={product}/>
      </ComponentPlaceholder>

      <ComponentPlaceholder
        until={product?.id}
        style={{minHeight: "180px"}}
        className="margin-top-25"
      >
        <ProductInfo
          id="product-info"
          product={product}
          className="margin-top-25"
          style={{fontSize: "14px"}}
        />
      </ComponentPlaceholder>

      <ComponentPlaceholder
        until={product?.id}
        style={{minHeight: "100px"}}
        className="margin-top-25"
      >
        <Ingredients product={product} className="margin-top-25"/>
      </ComponentPlaceholder>

      {product?.nutritionalInfo && <>
        <Title3 className="text-strong margin-top-25 margin-bottom-10">
          {product?.nutritionalInfo?.label}
        </Title3>
        <HorizontalScroll>
          <NutritionalInfoPDP nutritionalInfo={product.nutritionalInfo}/>
        </HorizontalScroll>
      </>}

      <ComponentPlaceholder
        until={product?.id}
        style={{minHeight: "100px"}}
        className="margin-top-20"
      >
        {!!product?.allergens?.length && <>
          <Title3 className="text-strong margin-top-20 margin-bottom-20">
            {t("farmy_product.allergens.header")}
          </Title3>
          <AllergensPDP allergens={product?.allergens}/>
        </>}
      </ComponentPlaceholder>

      <FarmyColumnSet>
        <FarmyColumn>
          <RecommendationsPDP product={product}/>
        </FarmyColumn>
      </FarmyColumnSet>
    </Container>
  </div>;
};

export default ProductPageMobile;
